import html2canvas from "html2canvas";
import OverallSentiment from "./OverallSentiment/OverallSentiment";
import ConversationOverTimeWithAverageBand from "./ConversationOverTimeWithAverageBand/ConversationOverTimeWithAverageBand";
import SentimentOvertime from "./SentimentOverTime/SentimentOverTime";
import Moment from "./MomentAnalysis/Moment";
import MomentsOvertime from "./MomentsOvertime/MomentsOvertime";
import EngagementOverTime from "./ImpactOverTime/EngagementOverTime";
import TopKeywords from "./TopKeywords/TopKeywords";
import PositiveSentimentPercentOverTime from "./PositiveSentimentOverTime/PositiveSentimentPercentOverTime";
import OverallEntityAnalysis from "./OverallEntityAnalysis/OverallEntityAnalysis";
import PlatformWiseEntityAnalysis from "./PlatformWiseEntityAnalysis/PlatformWiseEntityAnalysis";
import ChannelAnalysis from "./ChannelAnalysis/ChannelAnalysis";
import VolumeOfNews from "./VolumeOfNews/VolumeOfNews";
import UniqueUsersOverTime from "./UniqueUsersOverTime/UniqueUsersOverTime";
import ChannelAnalEngagementWise from "./ChannelAnalEngagementWise/ChannelAnalEngagementWise";
import PlatformWiseMediaBreakdown from "./PlatformWiseMediaBreakdown/PlatformWiseMediaBreakdown";
import EntitywiseSentimentBreakup from "./EntitywiseSentimentBreakup/EntitywiseSentimentBreakup";
import EstReach from "./EstReach/EstReach";
import MentionsMap from "./MentionsMap/MentionsMap";
import OverallShareOfVoice from "./OverallShareOfVoice/OverallShareOfVoice";
import OverallShareOfVoiceBySubtopics from "./OverallShareOfVoiceBySubtopics/OverallShareOfVoiceBySubtopics";
import ShareOfVoiceNews from "./ShareOfVoiceNews/ShareOfVoiceNews";
import TopicWiseSentimentBreakup from "./TopicWiseSentimentBreakup/TopicWiseSentimentBreakup";
import TopicWiseStackedSentimentBreakup from "./TopicWiseStackedSentimentBreakup/TopicWiseStackedSentimentBreakup";
import TopInfluencers from "./TopInfluencers/TopInfluencers";
import GeneralTrends from "./GeneralTrends/GeneralTrends";
import GeneralTrendsWithTopics from "./GeneralTrendsWithTopics/GeneralTrendsWithTopics";
import WordCloud from "./WordCloud/WordCloud";
import NetSentiment from "./NetSentiment/NetSentiment";
import RawConversations from "./RawConversations/RawConversations";
import LeaderboardHealth from "./LeaderboardHealth/LeaderboardHealth";
import PlatformWiseSentimentAnalysis from "./PlatformWiseSentimentAnalysis/PlatformWiseSentimentAnalysis";
import ShareOfVoiceWithSubTopics from "./ShareOfVoiceWithSubTopics/ShareOfVoiceWithSubTopics";
import OverallShareOfVoiceForObjects from "./ShareOfVoiceForObjects/OverallShareOfVoiceForObjects";
import OverallShareOfVoiceForLogo from "./ShareOfVoiceForLogo/OverallShareOfVoiceForLogo";
import OverallShareOfVoiceForScenes from "./ShareOfVoiceForScenes/OverallShareOfVoiceForScenes";
import TopicWisePlatformAnalysis from "./TopicWisePlatformAnalysis/TopicWisePlatformAnalysis";
import EngagementOverTimeBySubtopic from "./EngagementOverTimeBySubtopic/EngagementOverTimeBySubtopic";
import SubTopicWisePlatformAnalysis from "./SubTopicWisePlatformAnalysis/SubTopicWisePlatformAnalysis";
import { chartColors } from "../../../../lib/utils";
import jsPDF from "jspdf";
import * as d3 from "d3";
import TopTopics from "./TopTopics/TopTopics";
import OCRWordCloud from "./OcrWordCloud/OCRWordCloud";

import moment from "moment";

import Highcharts from "highcharts";
import TotalMentions from "./TotalValueCharts/TotalMentions";
import TotalEstimatedReach from "./TotalValueCharts/TotalEstimatedReach";
import TotalUniqueUsers from "./TotalValueCharts/TotalUniqueUsers";
import TotalEngagement from "./TotalValueCharts/TotalEngagement";
import TotalNegativeSentiment from "./TotalValueCharts/TotalNegativeSentiment";
import PageViewOvertime from "../../FbInsights/PageViewOvertime";
import PageLikesOvertime from "../../FbInsights/PageLikesOvertime";
import PageEngagementOvertime from "../../FbInsights/PageEngagementOvertime";
import PageReachOvertime from "../../FbInsights/PageReachOvertime";
import PostLikesOvertime from "../../FbInsights/PostLikesOvertime";
import AudienceByAge from "../../FbInsights/AudienceByAge";
import AudienceByGender from "../../FbInsights/AudienceByGender";
import AudienceByCountries from "../../FbInsights/AudienceByCountries";
import TotalFollowers from "../../EnhancedInsights/modules/TwitterInsights/components/TotalValueCharts/TotalFollowers";
import TotalFollowings from "../../EnhancedInsights/modules/TwitterInsights/components/TotalValueCharts/TotalFollowings";
import TotalTweets from "../../EnhancedInsights/modules/TwitterInsights/components/TotalValueCharts/TotalTweets";
import FollowersOvertime from "../../EnhancedInsights/modules/TwitterInsights/components/FollowersOverTime/FollowersOverTime";
import LikesOvertime from "../../EnhancedInsights/modules/TwitterInsights/components/LikesOverTime/LikesOverTime";
import ImpressionOvertime from "../../EnhancedInsights/modules/TwitterInsights/components/ImpressionOverTime/ImpressionOverTime";
import RetweetOvertime from "../../EnhancedInsights/modules/TwitterInsights/components/RetweetOverTime/RetweetOverTime";
import EngagementOvertime from "../../EnhancedInsights/modules/TwitterInsights/components/EngagementOverTime/EngagementOverTime";
import AverageEngagementOverTime from "../../EnhancedInsights/modules/TwitterInsights/components/AverageEngagementOverTime/AverageEngagementOverTime";
import QuotesOverTime from "../../EnhancedInsights/modules/TwitterInsights/components/QuotesOverTime/QuotesOverTime";
import RepliesOvertime from "../../EnhancedInsights/modules/TwitterInsights/components/RepliesOverTime/RepliesOverTime";
import FollowersLostAndGain from "../../EnhancedInsights/modules/TwitterInsights/components/FollowersLostAndGain/FollowersLostAndGain";
import RecentPosts from "../../EnhancedInsights/modules/TwitterInsights/components/RecentPosts/RecentPosts";
import PostTypeDistribution from "../../EnhancedInsights/modules/TwitterInsights/components/PostTypeDistribution/PostTypeDistribution";
import AvgEngagementPerTweetType from "../../EnhancedInsights/modules/TwitterInsights/components/AvgEngagementPerTweetType/AvgEngagementPerTweetType";
import ImpressionPerTweetType from "../../EnhancedInsights/modules/TwitterInsights/components/ImpressionPerTweetType/ImpressionPerTweetType";
import VideoViewsOvertime from "../../EnhancedInsights/modules/TwitterInsights/components/VideoViewsOverTime/VideoViewsOverTime";
import AudienceMetrics from "../../EnhancedInsights/modules/InstagramInsights/components/AudienceMetrics/AudienceMetrics";
import FollowersChangeOverTime from "../../EnhancedInsights/modules/InstagramInsights/components/FollowersChangeOverTime/FollowersChangeOverTime";
import ProfileViewsOverTime from "../../EnhancedInsights/modules/InstagramInsights/components/ProfileViewsOverTime/ProfileViewsOverTime";
import InstagramEngagementOverTime from "../../EnhancedInsights/modules/InstagramInsights/components/EngagementOverTime/EngagementOverTime";
import InstagramPostsLikes from "../../EnhancedInsights/modules/InstagramInsights/components/PostsLikes/PostsLikes";
import InstagramPostsComments from "../../EnhancedInsights/modules/InstagramInsights/components/PostsComments/PostsComments";
import InstagramPostImpressions from "../../EnhancedInsights/modules/InstagramInsights/components/PostImpressions/PostImpressions";
import InstagramPostReach from "../../EnhancedInsights/modules/InstagramInsights/components/PostReach/PostReach";
import StoryEngagementOverTime from "../../EnhancedInsights/modules/InstagramInsights/components/StoryEngagementOverTime/StoryEngagementOverTime";
import FollowersCount from "../../EnhancedInsights/modules/InstagramInsights/components/FollowersCount/FollowersCount";
import InstagramTotalReach from "../../EnhancedInsights/modules/InstagramInsights/components/TotalReach/TotalReach";
import InstagramTotalEngagement from "../../EnhancedInsights/modules/InstagramInsights/components/TotalEngagement/TotalEngagement";
import ProductAttributesSentiment from "./ProductAttributesSentiment/ProductAttributesSentiment";
import ShareOfVoiceForProductAttributes from "./ShareOfVoiceForProductAttributes/ShareOfVoiceForProductAttributes";
import CompetitorInsightsTableChart from "../../EnhancedInsights/modules/CompetitorInsights/components/CompetitorInsightsTableChart/CompetitorInsightsTableChart";
import CompetitorRecentPosts from "../../EnhancedInsights/modules/CompetitorInsights/components/CompetitorRecentPosts/CompetitorRecentPosts";
import UniqueUsersOverTimeByTopic from "./UniqueUsersOverTimeByTopic/UniqueUsersOverTimeByTopic";
import EngagementOverTimeByTopic from "./EngagementOverTimeByTopic/EngagementOverTimeByTopic";
import UniqueUsersOverTimeBySubTopic from "./UniqueUsersOverTimeBySubTopic/UniqueUsersOverTimeBySubTopic";
import ShareOfVoiceForEmotionsAnalytics from "./ShareOfVoiceForEmotionsAnalytics/ShareOfVoiceForEmotionsAnalytics";
import TopicWiseEmotionsBreakdown from "./TopicWiseEmotionsBreakdown/TopicWiseEmotionsBreakdown";
import FbRecentPosts from "../../FbInsights/fbRecentPosts/FbRecentPosts";
import IgRecentPosts from "../../EnhancedInsights/modules/InstagramInsights/components/IgRecentPosts/IgRecentPosts";
import TotalReachCount from "../../FbInsights/TotalValue/TotalReachCount";
import TotalEngagementCount from "../../FbInsights/TotalValue/TotalEngagementCount";
import TotalFollowersCount from "../../FbInsights/TotalValue/TotalFollowersCount";
import FbPostTypeDistribution from "../../FbInsights/PostTypeDistribution/FbPostTypeDistribution";
import FBPostsOvertime from "../../FbInsights/FBPostsOvertime";
import InstagramPostsOvertime from "../../EnhancedInsights/modules/InstagramInsights/components/PostsOvertime/PostsOvertime";
import InstagramStoryOvertime from "../../EnhancedInsights/modules/InstagramInsights/components/StoryOvertime/StoryOvertime";
import CompetitorByHashtags from "../../EnhancedInsights/modules/CompetitorInsights/components/CompetitorByHashtags/CompetitorByHashtags";
import IgRecentStories from "../../EnhancedInsights/modules/InstagramInsights/components/IgRecentStories/IgRecentStories";
import CompetitorByEngagement from "../../EnhancedInsights/modules/CompetitorInsights/components/CompetitorByEngagement/CompetitorByEngagement";
import TweetsOverTime from "../../EnhancedInsights/modules/TwitterInsights/components/TweetsOverTime/TweetsOverTime";
import PostShares from "../../FbInsights/PostShares";
import PostComments from "../../FbInsights/PostComments";
import StoryMediaBreakup from "../../EnhancedInsights/modules/InstagramInsights/components/StoryMediaBreakup/StoryMediaBreakup";
import DashboardEngagementOverTime from "./DashboardEngagementOverTime/DashboardEngagementOverTime";
import TopicWiseEngagementOverTime from "./TopicWiseEngagementOverTime/TopicWiseEngagementOverTime";
import AdvanceCustomChart from "./AdvaceCustomChart/AdvanceCustomChart";

export const red_colors = ["#e6b8af", "#de7e6b", "#cc412b", "#a62420", "#7a0400"];
export const green_colors = ["#b7d8a9", "#6aa84f", "#569d00", "#37761c", "#274e11"];
export const neutral_colors = "#959595";

export const radialColor = (color) => ({
    radialGradient: {
        cx: 0.4,
        cy: 0.4,
        r: 0.8,
    },
    stops: [
        [0, Highcharts.color(color).setOpacity(0.8).brighten(0.4).get("rgba")], // lighten
        [1, Highcharts.color(color).setOpacity(0.8).get("rgba")],
    ],
});

export const replaceEmoji = (str) => {
    let regex =
        /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    return str.replace(regex, "");
};

const revMapSubType = {
    "person-male": "male",
    "person-female": "female",
    "person-unknown": "unknown",
    "non-person-news": "news",
    "non-person-brand": "brand",
    "non-person-unknown": "unknown",
};

export const fbInsightsTabPanes = [{ menuItem: "FACEBOOK" }];

export const charts = [
    {
        name: "overallShareOfVoice",
        title: "OVERALL SHARE OF VOICE",
        label: "Overall Share of Voice",
        component: OverallShareOfVoice,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: { api: "volume-of-conversation", "aggs-interval": true } },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        isTopicRequired: true,
        chartgroup: ["shareOfVoice"],
    },
    {
        name: "overallShareOfVoiceBySubtopics",
        title: "SHARE OF VOICE BY SUB-TOPICS",
        label: "Share Of Voice By Subtopics",
        component: OverallShareOfVoiceBySubtopics,
        // api: "volOfConvSubtopicsCount",
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: { api: "volume-of-conversation", "aggs-interval": true } },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        isTopicRequired: true,
        chartgroup: ["shareOfVoice"],
    },
    {
        name: "shareOfVoiceNews",
        title: "SHARE OF VOICE NEWS",
        label: "Share Of Voice News",
        component: ShareOfVoiceNews,
        // api: "volOfConvSubtopicsCount",
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {} },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        isTopicRequired: true,
        chartgroup: ["shareOfVoice"],
    },
    {
        name: "estReach",
        title: "ESTIMATED REACH",
        label: "Estimated Reach",
        component: EstReach,
        api: "conversation-over-time-platformwise-estimated-reach",
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {} },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["impactAnalysis"],
    },
    {
        name: "overallEntityAnalysis",
        title: "OVERALL ENTITY ANALYSIS",
        label: "Overall Entity Analysis",
        component: OverallEntityAnalysis,
        api: "entity-sub-type-breakup",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "platformWiseEntityAnalysis",
        title: "ENTITY ANALYSIS",
        label: "Entity Analysis",
        component: PlatformWiseEntityAnalysis,
        api: "platforms-with-entity-sub-type-breakup",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["platformAnalysis"],
    },
    {
        name: "platformWiseMediaBreakdown",
        title: "PLATFORMWISE MEDIA TYPE ANALYSIS",
        label: "Platformwise Media Type Analysis",
        component: PlatformWiseMediaBreakdown,
        api: "platforms-with-media-breakup",
        singleWidget: false,
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["platformAnalysis"],
    },
    {
        name: "topicWiseSentimentBreakup",
        title: "TOPICWISE SENTIMENT BREAKUP",
        label: "Topicwise Sentiment Breakup",
        component: TopicWiseSentimentBreakup,
        api: "",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        isTopicRequired: true,
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "subtopicWiseSentimentBreakup",
        title: "SUBTOPICWISE SENTIMENT BREAKUP",
        label: "SubTopicwise Sentiment Breakup",
        component: TopicWiseSentimentBreakup,
        api: "",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        isTopicRequired: true,
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "topicWiseStackedSentimentBreakup",
        title: "TOPICWISE STACK SENTIMENT BREAKUP",
        label: "Topicwise Stack Sentiment Breakup",
        component: TopicWiseStackedSentimentBreakup,
        api: "",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        isTopicRequired: true,
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "subtopicWiseStackedSentimentBreakup",
        title: "SUBTOPICWISE STACK SENTIMENT BREAKUP",
        label: "SubTopicwise Stack Sentiment Breakup",
        component: TopicWiseStackedSentimentBreakup,
        api: "",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        isTopicRequired: true,
        chartgroup: ["sentimentAnalysis"],
    },
    { name: "topInfluencers", title: "TOP INFLUENCERS", component: TopInfluencers, chartgroup: ["influencerCharts"] },
    {
        name: "entitywiseSentimentBreakup",
        title: "ENTITYWISE DETAILED SENTIMENT BREAKUP",
        label: "Entitywise Detailed Sentiment Breakup",
        component: EntitywiseSentimentBreakup,
        api: "entity-sub-type-sentiments-breakup",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "channelAnalysis",
        title: "CHANNEL ANALYSIS",
        label: "Channel Analysis",
        component: ChannelAnalysis,
        api: "channel-analysis",
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {} },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["platformAnalysis"],
    },
    {
        name: "channelAnalysisEngagementWise",
        title: "CHANNEL ANALYSIS - IMPACT BREAKDOWN",
        label: "Channel Analysis Engagement Wise",
        component: ChannelAnalEngagementWise,
        api: "channel-analysis-by-impact_value",
        singleWidget: false,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {} },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["platformAnalysis"],
    },
    {
        name: "overallSentiment",
        title: "OVERALL SENTIMENT",
        label: "Overall Sentiment",
        component: OverallSentiment,
        api: "conversation-over-time-sentiment",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "leaderboardAndHealth",
        title: "LEADERBOARD AND HEALTH",
        label: "Leaderboard And Health",
        component: LeaderboardHealth,
        api: "volume-of-conversation,impact-stats,view-count-stats,like-count-stats,comment-count-stats,share-count-stats,estimated-reach-stats",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        isTopicRequired: true,
        chartgroup: ["genericTrends"],
    },
    {
        name: "platformWiseSentimentAnalysis",
        title: "PLATFORM WISE SENTIMENT ANALYSIS",
        label: "Platform Wise Sentiment Analysis",
        component: PlatformWiseSentimentAnalysis,
        api: "channel-analysis",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["platformAnalysis", "sentimentAnalysis"],
    },
    {
        name: "positiveSentimentPercentOverTime",
        title: "POSITIVE SENTIMENT PERCENTAGE OVER TIME",
        label: "Positive Sentiment Percent OverTime",
        component: PositiveSentimentPercentOverTime,
        api: "conversation-over-time-sentiment",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "netSentiment",
        title: "NET SENTIMENT",
        label: "Net Sentiment",
        component: NetSentiment,
        api: "conversation-over-time-sentiment",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "conversationOverTimeWithAverageBand",
        title: "VOLUME OF CONVERSATION OVER TIME WITH AVERAGE BANDS",
        label: "Conversation Over Time With Average Band",
        component: ConversationOverTimeWithAverageBand,
        api: "conversation-over-time-sentiment",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["genericTrends"],
    },
    {
        name: "sentimentOverTime",
        title: "SENTIMENT OVER TIME",
        label: "Sentiment Over Time",
        component: SentimentOvertime,
        api: "conversation-over-time-sentiment",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "conversationOverTime",
        title: "CONVERSATION OVER TIME",
        label: "Conversation Over Time",
        component: SentimentOvertime,
        api: "conversation-over-time-sentiment",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["genericCharts"],
    },

    {
        name: "volumeOfNews",
        title: "VOLUME OF NEWS",
        label: "Volume Of News",
        component: VolumeOfNews,
        api: "volume-of-conversation-source-type-breakup",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["genericCharts"],
    },
    {
        name: "engagementOverTime",
        title: "IMPACT OVER TIME",
        label: "Impact Over Time",
        component: EngagementOverTime,
        api: "engagement-overtime",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["audienceInsights"],
    },
    {
        name: "uniqueUsersOverTime",
        title: "UNIQUE USERS OVER TIME",
        label: "Unique Users Over Time",
        component: UniqueUsersOverTime,
        api: "unique-conversation-over-time-by-username",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["audienceInsights"],
    },
    {
        name: "generalTrends",
        title: "GENERAL TRENDS",
        label: "General Trends",
        component: GeneralTrends,
        "aggs-interval": true,
        api: "conversation-over-time-sentiment",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["genericTrends"],
    },
    {
        name: "wordcloud",
        title: "WORDCLOUD",
        label: "Wordcloud",
        component: WordCloud,
        api: "frequency-wordcloud",
        apiParams: { size: 100 },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        "aggs-interval": true,
        chartgroup: ["genericCharts"],
    },
    {
        name: "generalTrendsWithTopics",
        title: "GENERAL TRENDS WITH TOPICS",
        label: "General Trends With Topics",
        component: GeneralTrendsWithTopics,
        api: "conversation-over-time-sentiment",
        "aggs-interval": true,
        isTopicRequired: true,
        chartgroup: ["genericTrends"],
    },
    {
        name: "mentionsMap",
        title: "MENTIONS MAP",
        label: "Mentions Map",
        component: MentionsMap,
        api: "country_region_sentiments_breakup",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        // apiParams: { lat_long_exact: "yes" },
        chartgroup: ["audienceInsights"],
    },
    {
        name: "moments",
        title: "MOMENT",
        label: "Moments",
        api: "tag_categories_breakup_over_time",
        component: Moment,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {} },
        apiParams: { child_tags_of: 10900 },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["genericCharts"],
    },
    {
        name: "momentovertime",
        title: "MOMENT OVER TIME",
        label: "Moment Overtime",
        api: "tag_categories_breakup_over_time",
        component: MomentsOvertime,
        apiParams: { child_tags_of: 10900 },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["genericCharts"],
        "aggs-interval": true,
    },
    {
        name: "topKeywordsPositive",
        title: "Top Keywords in Positive Conversations",
        label: "Top Keywords in Positive Conversations",
        api: "wordcloud",
        component: TopKeywords,
        refineFilters: { sentiment: "positive" },
        chartgroup: ["genericCharts"],
    },
    {
        name: "topKeywordsNegative",
        title: "Top Keywords in Negative conversations",
        label: "Top Keywords in Negative conversations",
        api: "wordcloud",
        component: TopKeywords,
        refineFilters: { sentiment: "negative" },
        chartgroup: ["genericCharts"],
    },
    // { name: "topTopics", title: "TOP TOPICS", component: TopTopics,  api: "clustering" },
    {
        name: "topTopics",
        title: "TOP TOPICS",
        label: "Top Topics",
        component: TopTopics,
        api: "clustering",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["genericCharts"],
    },
    {
        name: "rawConversations",
        title: "Raw Conversations",
        label: "Raw Conversations",
        component: RawConversations,
        apiParams: { data: 1, recordsPerPage: 50, offset: 1, order: "desc", sortBy: "published_date_desc" },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["genericCharts"],
    },
    {
        name: "fbPageViews",
        title: "Page View Over Time",
        component: PageViewOvertime,
        api: "fb_page_view_by_total",
        chartCategory: "fb",
        chartType: "bar",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbPageFollowers",
        title: "Page Followers Change Over Time",
        component: PageLikesOvertime,
        api: "fb_page_follower_by_total",
        chartCategory: "fb",
        chartType: "bar",
        "aggs-interval": true,
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbPageEngagement",
        title: "Page Engagements Over Time",
        component: PageEngagementOvertime,
        api: "fb_page_engagement_by_total",
        chartCategory: "fb",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbPageReach",
        title: "Page Reach Over Time",
        component: PageReachOvertime,
        api: "fb_page_reach_by_total",
        chartCategory: "fb",
        chartType: "bar",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalPostLikes",
        title: "Post Likes Over Time",
        component: PostLikesOvertime,
        api: "fb_post_reaction",
        chartCategory: "fb",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalPostComments",
        title: "Post Comments",
        component: PostComments,
        api: "fb_post_reaction",
        chartCategory: "fb",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalPostShares",
        title: "Post Shares",
        component: PostShares,
        api: "fb_post_reaction",
        chartCategory: "fb",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalAudienceByAge",
        title: "Audience By Age",
        component: AudienceByAge,
        api: "fb_page_follower_by_gender_age",
        chartCategory: "fb",
        chartType: "bar",
        chartTypeOptions: { bar: {}, pie: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalAudienceByGender",
        title: "Audience By Gender",
        component: AudienceByGender,
        api: "fb_page_follower_by_gender_age",
        chartCategory: "fb",
        chartType: "bar",
        chartTypeOptions: { bar: {}, pie: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalAudienceByCountry",
        title: "Audience By Country",
        component: AudienceByCountries,
        api: "fb_page_follower_by_country",
        chartCategory: "fb",
        chartType: "bar",
        chartTypeOptions: { bar: {}, pie: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalReachCount",
        title: "Total Reach",
        component: TotalReachCount,
        api: "fb_page_reach_by_total",
        chartCategory: "fb",
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalEngagementCount",
        title: "Total Engagement",
        component: TotalEngagementCount,
        api: "fb_page_engagement_by_total",
        chartCategory: "fb",
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbTotalFollowersCount",
        title: "Total Followers",
        component: TotalFollowersCount,
        api: "fb_page_follower_by_total",
        chartCategory: "fb",
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbRecentPosts",
        title: "Recent Posts",
        component: FbRecentPosts,
        chartCategory: "fb",
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbPostTypeDistribution",
        title: "Post Type Distribution",
        component: FbPostTypeDistribution,
        chartCategory: "fb",
        chartType: "bar",
        chartTypeOptions: { bar: {}, pie: {} },
        chartgroup: ["fbInsights"],
    },
    {
        name: "fbPostsOvertime",
        title: "Posts over Time",
        component: FBPostsOvertime,
        chartCategory: "fb",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["fbInsights"],
    },

    {
        name: "IAoverallShareOfVoiceForLogo",
        title: "OVERALL SHARE OF VOICE FOR LOGO",
        component: OverallShareOfVoiceForLogo,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {} },
        api: "logo_overtime",
        chartgroup: ["imageAnalytics"],
        chartCategory: "IA",
        isTopicRequired: true,
        "aggs-interval": true,
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },

    {
        name: "IAoverallShareOfVoiceForObject",
        title: "OVERALL SHARE OF VOICE FOR OBJECTS",
        isTopicRequired: true,
        component: OverallShareOfVoiceForObjects,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {} },
        api: "object_overtime",
        chartgroup: ["imageAnalytics"],
        chartCategory: "IA",
        "aggs-interval": true,
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    {
        name: "IAoverallShareOfVoiceForScenes",
        title: "OVERALL SHARE OF VOICE FOR SCENES",
        isTopicRequired: true,
        component: OverallShareOfVoiceForScenes,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {} },
        api: "scene_overtime",
        chartgroup: ["imageAnalytics"],
        chartCategory: "IA",
        "aggs-interval": true,
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    {
        name: "twitterTotalFollowers",
        title: "Total Followers",
        component: TotalFollowers,
        api: "basic_metric",
        chartCategory: "twitter",
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterTotalFollowings",
        title: "Total Followings",
        component: TotalFollowings,
        api: "basic_metric",
        chartCategory: "twitter",
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterTotalTweets",
        title: "Total Tweets",
        component: TotalTweets,
        api: "basic_metric",
        chartCategory: "twitter",
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterFollowersOverTime",
        title: "Followers Over Time",
        component: FollowersOvertime,
        api: "follower_growth_overtime",
        chartCategory: "twitter",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterLikesOverTime",
        title: "Likes Over Time",
        component: LikesOvertime,
        api: "page_like_overtime",
        chartCategory: "twitter",
        getAvg: true,
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterImpressionOverTime",
        title: "Impression Over Time",
        component: ImpressionOvertime,
        api: "page_impression_overtime",
        chartCategory: "twitter",
        chartType: "line",
        getAvg: true,
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterRetweetsOverTime",
        title: "Retweets Over Time",
        component: RetweetOvertime,
        api: "page_retweet_overtime",
        chartCategory: "twitter",
        getAvg: true,
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterEngagementOverTime",
        title: "Engagement Over Time",
        component: EngagementOvertime,
        api: "page_engagement_overtime",
        chartCategory: "twitter",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterAverageEngagementOverTime",
        title: "Average Engagement Over Time",
        component: AverageEngagementOverTime,
        api: "page_avg_engagement_overtime",
        chartCategory: "twitter",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterQuotesOverTime",
        title: "Quotes Over Time",
        component: QuotesOverTime,
        api: "page_quote_overtime",
        chartCategory: "twitter",
        getAvg: true,
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterTweetsOverTime",
        title: "Tweets Over Time",
        component: TweetsOverTime,
        api: "tweet_overtime",
        chartCategory: "twitter",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterFollowersLostAndGained",
        title: "Followers Lost and Gained",
        component: FollowersLostAndGain,
        api: "follower_growth_overtime-gain",
        chartCategory: "twitter",
        chartType: "bar",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterRecentPosts",
        title: "Recent Posts",
        component: RecentPosts,
        api: "recent_posts",
        chartCategory: "twitter",
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterPostTypeDistribution",
        title: "Post Type Distribution",
        component: PostTypeDistribution,
        api: "tweet_type_distribution_overall",
        chartCategory: "twitter",
        chartType: "bar",
        chartTypeOptions: { bar: {}, pie: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterAvgEngagementPerTweetType",
        title: "Average Engagement Per Tweet Type",
        component: AvgEngagementPerTweetType,
        api: "avg_engagement_per_tweet_type",
        chartCategory: "twitter",
        chartType: "bar",
        chartTypeOptions: { bar: {}, pie: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterImpressionPerTweetType",
        title: "Impression Per Tweet Type",
        component: ImpressionPerTweetType,
        api: "impression_per_tweet_type",
        chartCategory: "twitter",
        getAvg: true,
        chartType: "bar",
        chartTypeOptions: { bar: {}, pie: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "twitterVideoViewsOverTime",
        title: "Video Views Over Time",
        component: VideoViewsOvertime,
        api: "video_views_overtime",
        chartCategory: "twitter",
        chartType: "bar",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["twitterInsights"],
    },
    {
        name: "IgAudienceMetrics",
        title: "Audience Metrics",
        component: AudienceMetrics,
        api: "insta_audience_by_gender_age",
        chartCategory: "instagram",
        chartType: "pie",
        chartTypeOptions: { pie: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgPageFollowers",
        title: "Page Followers",
        component: FollowersChangeOverTime,
        api: "insta_page_follower_change",
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { line: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgPageViews",
        title: "Page Views",
        component: ProfileViewsOverTime,
        api: "insta_page_profile_views",
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { line: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgPageEngagement",
        title: "Post Engagement",
        component: InstagramEngagementOverTime,
        api: "insta_page_profile_views",
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { line: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgPostsLikes",
        title: "Post Likes",
        component: InstagramPostsLikes,
        api: "insta_page_profile_views",
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { line: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgPostsComments",
        title: "Post Comments",
        component: InstagramPostsComments,
        api: "insta_page_profile_views",
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { line: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgPostImpressions",
        title: "Post Impressions",
        component: InstagramPostImpressions,
        api: "insta_page_profile_views",
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { line: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgPostReach",
        title: "Post Reach",
        component: InstagramPostReach,
        api: "insta_page_profile_views",
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { line: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgStoriesEngagement",
        title: "Stories Engagement",
        component: StoryEngagementOverTime,
        api: "insta_page_profile_views",
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { line: {}, bar: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgFollowersCount",
        title: "Followers Count",
        component: FollowersCount,
        api: "insta_page_profile_views",
        chartCategory: "instagram",
        chartType: "line",
        chartgroup: ["igInsights"],
    },
    {
        name: "IgtotalReach",
        title: "Total Reach",
        component: InstagramTotalReach,
        api: "insta_post_engagment_by_reach",
        chartCategory: "instagram",
        chartType: "line",
        chartgroup: ["igInsights"],
    },
    {
        name: "IgtotalEngagement",
        title: "Total Engagement",
        component: InstagramTotalEngagement,
        api: "insta_post_engagment_by_like_comment",
        chartCategory: "instagram",
        chartType: "line",
        chartgroup: ["igInsights"],
    },
    {
        name: "IgPostsOvertime",
        title: "Posts over Time",
        component: InstagramPostsOvertime,
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgStoriesOvertime",
        title: "Stories over time",
        component: InstagramStoryOvertime,
        chartCategory: "instagram",
        chartType: "line",
        chartTypeOptions: { bar: {}, line: {} },
        chartgroup: ["igInsights"],
    },
    {
        name: "IgStoriesMediaBreakup",
        title: "Story Media Breakdown",
        component: StoryMediaBreakup,
        chartCategory: "instagram",
        chartType: "bar",
        chartgroup: ["igInsights"],
    },
    {
        name: "IgRecentPosts",
        title: "Recent Posts",
        component: IgRecentPosts,
        chartCategory: "instagram",
        chartgroup: ["igInsights"],
    },
    {
        name: "IgRecentStories",
        title: "Recent Stories",
        component: IgRecentStories,
        chartCategory: "instagram",
        chartgroup: ["igInsights"],
    },
    {
        name: "totalMentions",
        title: "Total Mentions",
        component: TotalMentions,
        apiParams: { data: 0 },
        chartgroup: ["genericCharts"],
    },
    {
        name: "totalUniqueUsers",
        title: "Total Unique Users",
        component: TotalUniqueUsers,
        api: "total_unique_users",
        chartgroup: ["audienceInsights"],
    },
    {
        name: "totalNegativeSentiment",
        title: "Total Negative Sentiment",
        component: TotalNegativeSentiment,
        refineFilters: { sentiment: "negative" },
        apiParams: { data: 0 },
        chartgroup: ["sentimentAnalysis"],
    },
    {
        name: "totalEstimatedReach",
        title: "Total Estimated Reach",
        component: TotalEstimatedReach,
        api: "total_estimated_reach",
        chartgroup: ["impactAnalysis"],
    },
    {
        name: "totalEngagement",
        title: "Total Engagement",
        component: TotalEngagement,
        // api: "total_impact_value",
        api: "total_engagement_stats",
        chartgroup: ["audienceInsights"],
    },
    {
        name: "PAInsights",
        title: "Product Attribute Sentiment Analysis",
        component: ProductAttributesSentiment,
        // chartType: "bar",
        // chartTypeOptions: { pie: {}, bar: {}, line: {} },
        api: "channel-analysis-by-product-attribute-category-sentiment",
        chartgroup: ["productAttributes"],
        chartCategory: "PA",
        "aggs-interval": true,
        isTopicRequired: true,
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    {
        name: "ocrWordcloud",
        title: "OCR WORDCLOUD",
        label: "OCR Wordcloud",
        component: OCRWordCloud,
        api: "ocr-frequency-wordcloud",
        apiParams: { size: 100 },

        "aggs-interval": true,
        chartgroup: ["imageAnalytics"],
    },

    {
        name: "PAShareOfVoice",
        title: "Topicwise Product Attributes for Overall SOV by product attributes",
        component: ShareOfVoiceForProductAttributes,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {} },
        api: "channel-analysis-by-product-attribute-category-sov",
        chartgroup: ["productAttributes"],
        chartCategory: "PA",
        "aggs-interval": true,
        isTopicRequired: true,
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    {
        name: "engagementOverTimeByTopic",
        title: "Number of engagement over time by Topic",
        component: EngagementOverTimeByTopic,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {} },
        isTopicRequired: true,
        "aggs-interval": true,
        api: "engagement-overtime",
        chartgroup: ["audienceInsights"],
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    {
        name: "engagementOverTimeBySubTopic",
        title: "Subtopicwise Impact analysis",
        component: EngagementOverTimeBySubtopic,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {} },
        isTopicRequired: true,
        "aggs-interval": true,
        api: "engagement-overtime",
        chartgroup: ["audienceInsights"],
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    {
        name: "topicWiseStackedPlatformBreakdown",
        title: "Topic wise Stacked Platform Breakdown",
        component: TopicWisePlatformAnalysis,
        chartType: "bar",
        isTopicRequired: true,
        api: "channel-analysis",
        chartgroup: ["platformAnalysis"],
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    {
        name: "subTopicWiseStackedPlatformBreakdown",
        title: "Subtopic wise Stacked Platform Breakdown",
        component: SubTopicWisePlatformAnalysis,
        chartType: "bar",
        isTopicRequired: true,
        api: "channel-analysis",
        chartgroup: ["platformAnalysis"],
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    {
        name: "uniqueUsersOverTimebyTopic",
        title: "Unique users over time by Topic",
        component: UniqueUsersOverTimeByTopic,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: { api: "unique-conversation-over-time-by-username", "aggs-interval": true } },
        isTopicRequired: true,
        api: "total_unique_users",
        chartgroup: ["audienceInsights"],
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },

    {
        name: "EAShareOfVoice",
        title: "Topicwise Emotion Analytics",
        component: ShareOfVoiceForEmotionsAnalytics,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {}, stacked: {} },
        api: "channel-analysis-by-emotion-analytics",
        chartgroup: ["emotionsAnalytics"],
        chartCategory: "EA",
        "aggs-interval": true,
        isTopicRequired: true,
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        // chartgroup: ["shareOfVoice"],
    },
    {
        name: "shareOfVoiceSubTopicWiseBreakDown",
        title: "Volume of Conversation Subtopicwise",
        component: ShareOfVoiceWithSubTopics,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: { api: "volume-of-conversation", "aggs-interval": true } },
        isTopicRequired: true,
        "aggs-interval": true,
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["shareOfVoice"],
    },

    {
        name: "topicWiseStackedEmotionsBreakdown",
        title: "Topicwise Stacked Emotions Breakdown",
        component: TopicWiseEmotionsBreakdown,
        chartType: "bar",
        isTopicRequired: true,
        api: "channel-analysis-by-emotion-analytics",
        chartgroup: ["emotionsAnalytics"],
        chartCategory: "EA",
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },
    // {
    //     name: "compTableChart",
    //     title: "Competitor Insights Table Chart",
    //     component: CompetitorInsightsTableChart,
    //     chartgroup: ["competitorInsights"],
    //     chartCategory: "comp",
    // },
    // {
    //     name: "compRecentPosts",
    //     title: "Competitor Posts",
    //     component: CompetitorRecentPosts,
    //     chartgroup: ["competitorInsights"],
    //     chartCategory: "comp",
    // },

    {
        name: "compTableChart",
        title: "Competitor Insights Table Chart",
        component: CompetitorInsightsTableChart,
        chartgroup: ["competitorInsights"],
        chartCategory: "comp",
    },
    {
        name: "compRecentPosts",
        title: "Competitor Posts",
        component: CompetitorRecentPosts,
        chartgroup: ["competitorInsights"],
        chartCategory: "comp",
    },
    {
        name: "compByHashtags",
        title: "Competitor Hashtags",
        component: CompetitorByHashtags,
        chartgroup: ["competitorInsights"],
        chartCategory: "comp",
    },
    {
        name: "compByEngagement",
        title: "Competitor Engagements",
        component: CompetitorByEngagement,
        chartType: "line",
        chartgroup: ["competitorInsights"],
        chartCategory: "comp",
    },
    {
        name: "uniqueUsersOverTimebySubTopic",
        title: "Unique users over time by Subtopic",
        component: UniqueUsersOverTimeBySubTopic,
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: { api: "unique-conversation-over-time-by-username", "aggs-interval": true } },
        isTopicRequired: true,
        api: "total_unique_users",
        chartgroup: ["audienceInsights"],
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
    },

    //EngagementOverTime

    {
        name: "dashboardEngagementOverTime",
        title: "Engagement over Time",
        label: "Engagement over Time",
        component: DashboardEngagementOverTime,
        isTopicRequired: true,
        "aggs-interval": true,
        api: "engagement_datewise_breakdown",
        // apiParams: { data: 1, recordsPerPage: 50, offset: 1, order: "desc", sortBy: "published_date_desc" },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["genericCharts"],
    },

    {
        name: "TopicwiseEngagementOverTime",
        title: "Topicwise Engagement over Time",
        label: "Topicwise Engagement over Time",
        component: TopicWiseEngagementOverTime,
        isTopicRequired: true,
        "aggs-interval": true,
        api: "engagement_datewise_breakdown_with_exclusion",
        chartType: "bar",
        chartTypeOptions: { pie: {}, bar: {}, line: {} },
        // apiParams: { data: 1, recordsPerPage: 50, offset: 1, order: "desc", sortBy: "published_date_desc" },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        chartgroup: ["genericCharts"],
    },
    //Advacne Chart Adition
    {
        name: "advance_chart",
        title: "Custom Chart",
        label: "Custom Chart",
        component: AdvanceCustomChart,
        // isTopicRequired: true,
        "aggs-interval": true,
        // api: "engagement_datewise_breakdown_with_exclusion",
        chartType: "stacked",
        // chartTypeOptions: { pie: {}, bar: {}, line: {} },
        chartTypeOptions: { line: {}, stacked: {} },
        // apiParams: { data: 1, recordsPerPage: 50, offset: 1, order: "desc", sortBy: "published_date_desc" },
        insights_configuration: {
            componentsToRender: [
                "platformWiseMediaBreakdown",
                "overallEntityAnalysis",
                "topTopics",
                "wordcloud",
                "entitywiseSentimentBreakup",
                "topKeywordsPositive",
                "topKeywordsNegative",
                "rawConversations",
            ],
        },
        // chartgroup: ["advanceChart"],
    },
];

export const chartGroups = {
    sentimentAnalysis: { name: "Sentiment Analysis" },
    platformAnalysis: { name: "Platform Analysis" },
    shareOfVoice: { name: "Share of Voice" },
    genericTrends: { name: "Generic Trends" },
    genericCharts: { name: "Generic Charts" },
    audienceInsights: { name: "Audience Insights" },
    impactAnalysis: { name: "Impact Analysis" },
    influencerCharts: { name: "Influencer Charts" },
    fbInsights: { name: "Facebook Insights", icon: "fbInsights" },
    imageAnalytics: { name: "Image Analytics" },
    twitterInsights: { name: "X Insights", icon: "twitterInsights" }, // Changed Twitter name to X
    igInsights: { name: "Instagram Insights", icon: "igInsights" },
    productAttributes: { name: "Product Attributes" },
    emotionsAnalytics: { name: "Emotions Analytics" },
    // competitorInsights: { name: "Competitor Insights" },
    competitorInsights: { name: "Competitor Insights" },
    // advanceChart: { name: "Custom Chart" },
};

export const getChart = (name) => {
    return charts.find((chart) => chart.name === name);
};

// COLORS
export const getGenderColor = (gender) => {
    switch (gender) {
        case "male":
            return "#2d8df9";
        case "female":
            return "#da0383";
        case "unknown":
            return "#6f6f6f";
        case "brand":
            return "orange";
        case "news":
            return "red";
        case "video":
            return chartColors[20];
        case "videos":
            return chartColors[12];
        case "image":
            return chartColors[30];
        case "text":
            return chartColors[26];
        default:
            return "#6f6f6f";
    }
};

export const getSentimentColor = (sentiment) => {
    switch (sentiment) {
        case "total":
            return "#3c3c3c";
        case "positive":
            return "#8bc34a";
        case "negative":
            return "#fd3333";
        case "neutral":
            return "#f7c377";
        case "like":
            return "#8bc34a";
        case "share":
            return "#fd3333";
        case "comment":
            return "#f7c377";
        // case "views":
        //     return "#f7c377";
        default:
            return "#6f6f6f";
    }
};

export const getStrokeColor = (platform) => {
    switch (platform) {
        case "twitter":
            return "#54abed";
        case "instagram":
            return "#8a3ab9";
        case "news":
            return "#ed4035";
        case "fbcomment":
            return "#3c5a97";
        case "facebook":
            return "#3c5a97";
        case "blog":
            return "#f4811f";
        case "forum":
            return "#6c6d70";
        case "youtube":
            return "#d02727";
        case "Ongoing":
            return "#BBB7DD";
        case "Historic":
            return "#515F77";
        case "buzz":
            return "#ec3b28";
        case "factivanews":
            return "#0091c8";
        case "lexisnexis":
            return "#0091c8";
        case "rating_review":
            return "#d02727";
        case "pinterest":
            return "#ed4035";
        case "reddit":
            return "#6c6d70";
        case "tiktok":
            return "#69C9D0";
        default:
            return "#6f6f6f";
    }
};

export const getEntityColor = (gender) => {
    switch (gender) {
        case "male":
            return "#9998F6";
        case "female":
            return "#C765B4";
        case "unknown":
            return "#AA08FF";
        case "brand":
            return "#4DB1DC";
        case "news":
            return "#FFBA38";
        case "video":
            return chartColors[20];
        case "videos":
            return chartColors[12];
        case "image":
            return chartColors[30];
        case "text":
            return chartColors[26];
        case "person":
            return "#9998F6";
        case "non-person":
            return "#AA08FF";
        default:
            return "#6f6f6f";
    }
};
export const getPlatformColorCode = (platform) => {
    switch (platform) {
        case "Twitter":
            return "#54abed";
        case "X":
            return "#54abed";
        case "Facebook":
            return "#3c5a97";
        case "Facebook Comments":
            return "#3c5a97";
        case "Instagram":
            return "#8a3ab9";
        case "News":
            return "#ed4035";
        case "TikTok":
            return "#69C9D0";
        case "Reddit":
            return "#6c6d70";
        case "TV Eyes":
            return "#1463A7";
        case "Yocket":
            return "#F57C00";
        case "ShareChat":
            return "#F7D21C";
        case "MxTakatak":
            return "#40106F";
        case "China-News":
            return "#FACD00";
        case "E-commerce":
            return "#FACD00";
        case "China-Blogs":
            return "#FACD00";
        case "Forums":
            return "#fade5a";
        case "YouTube":
            return "#d02727";
        case "Pinterest":
            return "#ed4035";
        case "LexisNexis":
            return "#0091c8";
        case "Blog":
            return "#f4811f";
        case "Buzz":
            return "#ec3b28";
        case "Koo":
            return "#FACD00";
        case "Ongoing":
            return "#BBB7DD";
        case "Historic":
            return "#515F77";
        case "Factiva News":
            return "#0091c8";
        case "Rating And Reviews":
            return "#d02727";
        case "Google Business":
            return "#d02727";
        case "Google Play Store":
            return "#1463A7";

        case "youtube":
            return "#d02727";
        default:
            return "#6f6f6f";
    }
};

export const mFormatter = (num) => {
    if (Math.abs(num) > 999999) {
        return Math.sign(num) * (Math.abs(num) / 1000000).toString().match(/^-?\d+(?:\.\d{0,1})?/)[0] + "M";
    } else if (Math.abs(num) > 999) {
        return Math.sign(num) * (Math.abs(num) / 1000).toString().match(/^-?\d+(?:\.\d{0,1})?/)[0] + "K";
    } else {
        return Math.sign(num) * Math.abs(num);
    }
};

export const leaderboardAndHealthSortOptions = [
    // { label: "Sort By", value: "", disabled: true },
    { label: "Total Mentions", value: "total_mentions" },
    { label: "Average Mentions", value: "avg_mentions" },
    { label: "Total Reach", value: "total_reach" },
    { label: "Average Reach", value: "avg_reach" },
    { label: "Total Engagement", value: "total_engagement" },
    { label: "Average Engagement", value: "avg_engagement" },
    { label: "Average Impact Score", value: "avg_impact_score" },
    { label: "Likes", value: "like_count" },
    { label: "Shares", value: "share_count" },
    { label: "Comments", value: "comment_count" },
    { label: "Views", value: "view_count" },
];

export const downloadCSVData = (data, filename) => {
    let csv = "";

    data.forEach(function (row) {
        row = row.map((x) => ([undefined, null].includes(x) ? 0 : x));

        csv += row.map((x) => `"${x}"`).join(",");
        csv += `\n`;
    });

    var pom = document.createElement("a");
    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    var url = URL.createObjectURL(blob);
    pom.href = url;
    pom.setAttribute("download", `${filename}.csv`);
    window.document.body.appendChild(pom);
    pom.click();
    window.document.body.removeChild(pom);
};

export const downloadCanvasWithTitle = (canvas, title, descriptionText) => {
    console.log("hello", canvas, title, descriptionText);
    let description = null,
        color = null,
        position = null,
        fontSize = null;
    if (descriptionText) {
        description = descriptionText.split("$$$$$")[0];
        color = descriptionText.split("$$$$$")[1] ? descriptionText.split("$$$$$")[1] : "#000000";
        position = descriptionText.split("$$$$$")[2] ? descriptionText.split("$$$$$")[2] : "top";
        fontSize = descriptionText.split("$$$$$")[3] ? descriptionText.split("$$$$$")[3] : "20px";
    }
    let titleCanvas = document.createElement("canvas");
    titleCanvas.width = canvas.width;
    if (description && description.length) {
        titleCanvas.height = canvas.height + 150;
    } else {
        titleCanvas.height = canvas.height + 50;
    }
    let ctx = titleCanvas.getContext("2d");
    if (description && description.length) {
        if (position === "top") {
            ctx.drawImage(canvas, 0, 150);
        } else {
            ctx.drawImage(canvas, 0, 50);
        }
    } else {
        ctx.drawImage(canvas, 0, 50);
    }
    ctx.font = "14px sans-serif";
    ctx.fillStyle = color;
    ctx.textAlign = "center";
    printAt(ctx, title, canvas.width / 2, 25, 15, canvas.width);

    if (description && description.length) {
        ctx.font = fontSize;
        ctx.textAlign = "center";
        ctx.fillStyle = color;
        ctx.background = "red";
        var words = description.split(" ");
        var line = "";
        var x = titleCanvas.width / 2;
        var y;
        if (position === "top") {
            y = 100;
        } else {
            y = titleCanvas.height - 50;
        }
        for (var n = 0; n < words.length; n++) {
            var testLine = line + words[n] + " ";
            var metrics = ctx.measureText(testLine);
            var testWidth = metrics.width;
            if (testWidth > titleCanvas.width - 10 && n > 0) {
                ctx.fillText(line, x, y);
                line = words[n] + " ";
                y += 25;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
    }
    let a = document.createElement("a");
    a.href = titleCanvas.toDataURL("image/png");
    a.download = title + ".png";
    a.style.visibility = "hidden";
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
};

function printAt(context, text, x, y, lineHeight, fitWidth) {
    fitWidth = fitWidth || 0;

    if (fitWidth <= 0) {
        context.fillText(text, x, y);
        return;
    }

    for (var idx = 1; idx <= text.length; idx++) {
        var str = text.substr(0, idx);
        if (context.measureText(str).width > fitWidth) {
            context.fillText(text.substr(0, idx - 1), x, y);
            printAt(context, text.substr(idx - 1), x, y + lineHeight, lineHeight, fitWidth);
            return;
        }
    }
    context.fillText(text, x, y);
}

function getCanvasWithTitle(canvas, title, descriptionText) {
    let description = null,
        color = null,
        position = null,
        fontSize = null;
    let titleCanvas = document.createElement("canvas");
    titleCanvas.width = canvas.width;
    titleCanvas.height = canvas.height + 50;
    let ctx = titleCanvas.getContext("2d");
    ctx.drawImage(canvas, 0, 50);
    ctx.font = `bolder 20px sans-serif`;
    ctx.textAlign = "center";
    if (title.includes("conversationOverTimeWithAverageBand")) {
        let x = title.split("-");
        if (x[0] === "conversationOverTimeWithAverageBand" && x[1] === "conversationOverTimeWithAverageBand") {
            x[0] = "volumeOfConversationOverTimeWithAverageBands";
            x[1] = "volumeOfConversationOverTimeWithAverageBands";
        } else if (x[0] === "conversationOverTimeWithAverageBand") {
            x[0] = "volumeOfConversationOverTimeWithAverageBands";
        } else if (x[1] === "conversationOverTimeWithAverageBand") {
            x[1] = "volumeOfConversationOverTimeWithAverageBands";
        }
        title = x[0] + " - " + x[1];
    }
    if (title.includes("-") && title.includes("EngagementOverTime")) {
        let x = title.split("-");
        if (x[0] === "EngagementOverTime") x[0] = "ImpactOverTime";
        if (x[1] === "EngagementOverTime") x[1] = "ImpactOverTime";
        title = x[0] + " - " + x[1];
    }
    if (title === "platformWiseGenderAnal") {
        title = "entityAnalysis";
    }
    if (title === "fbinsights:totalPostLikes") {
        title = "postLikesOverTime";
    }
    if (title === "fbinsights:pageFollowers") {
        title = "pageFollowersChangeOverTime";
    }
    if (title === "fbinsights:pageEngagement") {
        title = "pageEngagementsOverTime";
    }
    if (title === "fbinsights:pageReach") {
        title = "pageReachOverTime";
    }
    if (title === "fbinsights:pageViews") {
        title = "pageViewsOverTime";
    }
    if (title === "genderwiseSentimentBreakup") {
        title = "entitywiseDetailedSentimentBreakup";
    }
    if (title === "platformWiseMediaBreakdown") {
        title = "platformwiseMediaTypeAnalysis";
    }
    if (title === "estReach") {
        title = "estimatedReach";
    }
    if (title === "overallGendAnal") {
        title = "overallEntityAnalysis";
    }
    if (title === "EngagementOverTime") {
        title = "ImpactOverTime";
    }
    if (title.includes("overallGendAnal")) {
        let x = title.split("-");
        if (x[0] === "overallGendAnal" && x[1] === "overallGendAnal") {
            x[0] = "overallEntityAnalysis";
            x[1] = "overallEntityAnalysis";
        } else if (x[0] === "overallGendAnal") {
            x[0] = "overallEntityAnalysis";
        } else if (x[1] === "overallGendAnal") {
            x[1] = "overallEntityAnalysis";
        }
        title = x[0] + " - " + x[1];
    }
    ctx.fillText(
        title
            .replace(/-/g, " - ")
            .replace(/([A-Z])/g, " $1")
            .toUpperCase(),
        titleCanvas.width / 2,
        50,
    );

    if (description && description.length) {
        ctx.font = fontSize + " Abel";
        ctx.textAlign = "center";
        ctx.fillStyle = color;
        var words = description.split(" ");
        var line = "";
        var x = titleCanvas.width / 2;
        var y;
        if (position === "top") {
            y = 100;
        } else {
            y = titleCanvas.height - 50;
        }
        for (var n = 0; n < words.length; n++) {
            var testLine = line + words[n] + " ";
            var metrics = ctx.measureText(testLine);
            var testWidth = metrics.width;
            if (testWidth > titleCanvas.width - 10 && n > 0) {
                ctx.fillText(line, x, y);
                line = words[n] + " ";
                y += 25;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
    }

    return titleCanvas;
}
// changed promise to async await
export const downloadCustomDashboard = async (n, names, descriptions, callback, downloadProgress) => {
    let temp_names = [];
    names.forEach((elem) => temp_names.push(elem));
    if (temp_names.includes("CHANNEL ANALYSIS")) {
        n++;
        d3.select(".channel-analysis.temp1-channel-analysis").style("display", "block");
        d3.select(".channel-analysis.temp2-channel-analysis").style("display", "block");
        temp_names.splice(names.indexOf("CHANNEL ANALYSIS") + 1, 0, "CHANNELWISE SENTIMENT ANALYSIS");
        // descriptions.splice(names.indexOf('CHANNEL ANALYSIS') + 1, 0, descriptions[names.indexOf('CHANNEL ANALYSIS')]);
    }
    var iterator;

    let hideables = document.getElementsByClassName("hideable");
    let styles = [];
    for (iterator = 0; iterator < hideables.length; iterator++) {
        styles.push(hideables[iterator].style.display);
        hideables[iterator].style.display = "none";
    }

    let dwnldList = document.getElementsByClassName("pdf_content");

    let screenShotList = [];
    for (let i = 0; i < dwnldList.length; i++) {
        await html2canvas(dwnldList[i], {
            backgroundColor: null,
            useCORS: true,
        })
            .then((canvas) => {
                downloadProgress();
                screenShotList.push(canvas);
            })
            .catch((err) => false);
    }

    let canvasList = [];
    for (let i = 0; i < screenShotList.length; i++) {
        if (screenShotList) canvasList.push(getCanvasWithTitle(screenShotList[i], temp_names[i], descriptions[i]));
    }
    d3.select(".channel-analysis.temp1-channel-analysis").style("display", "none");
    d3.select(".channel-analysis.temp2-channel-analysis").style("display", "none");
    downloadPdf(canvasList, styles, hideables, n, callback);
};

function downloadPdf(canvases, styles, hideables, n, callback) {
    const user_name = JSON.parse(localStorage.getItem("company")) ? JSON.parse(localStorage.getItem("company")).user_name : "";

    var newCanvas = document.createElement("canvas");
    let newCanvasHeight = 0;
    for (var j = 0; j < n; j++) {
        newCanvasHeight += canvases[j].height;
    }
    newCanvas.height = newCanvasHeight + 150;
    let maxWidth = 0;
    for (var i = 0; i < canvases.length; i++) {
        if (maxWidth < canvases[i].width) {
            maxWidth = canvases[i].width;
        }
    }
    newCanvas.width = maxWidth;
    let newContext = newCanvas.getContext("2d");
    newContext.font = "20px sans-serif";
    newContext.drawImage(canvases[0], 0, 0);
    let curr_height = canvases[0].height;
    for (j = 1; j < n; j++) {
        newContext.drawImage(canvases[j], 0, curr_height);
        curr_height += canvases[j].height;
    }
    var pdf = new jsPDF("p", "mm", "a4");

    var ratio = newCanvas.width / newCanvas.height;
    var width = pdf.internal.pageSize.getWidth() + 50;
    var height = width / ratio;

    pdf.addPage(width, height);
    pdf.text(`${user_name} - Custom Dashboard - ${moment().format("DD MMM YYYY HH.mm")}`, 65, 20);
    pdf.addImage(newCanvas, "PNG", 0, 20, width, height);
    pdf.deletePage(1);
    pdf.save(`${user_name} - Custom Dashboard - ${moment().format("DD MMM YYYY HH.mm")}.pdf`);
    callback();

    for (var iterator = 0; iterator < hideables.length; iterator++) {
        hideables[iterator].style.display = styles[iterator];
    }
}

export const hashCode = (str) => {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
};

export const intToRGB = (i) => {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();

    let color = "00000".substring(0, 6 - c.length) + c;
    return "#" + color;
};

export const viewConversationsAction = (searchDataType) => {
    let win = null;
    if (searchDataType === 1) {
        win = window.open(`/conversations/0`, "_blank");
    } else {
        win = window.open(`/conversations/-999`, "_blank");
    }
    win.focus();
};

export const formatNumber = (number) => {
    if (!number) return null;
    if (Math.floor(number) != number) {
        number = number.toFixed(2);
        return number;
    }
    let decPlaces = 1;
    decPlaces = Math.pow(10, decPlaces);
    let abbrev = ["K", "M", "B", "t"];
    for (let i = abbrev.length - 1; i >= 0; i--) {
        let size = Math.pow(10, (i + 1) * 3);
        if (size <= number) {
            number = Math.round((number * decPlaces) / size) / decPlaces;
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            number += abbrev[i];
            break;
        }
    }
    return number;
};

export const getEndDate = ({ date, aggVal, filters, comparisionData, lastComparisonIndex }) => {
    let endDate;
    let tz = JSON.parse(localStorage.company).user_timezone_name;

    switch (aggVal) {
        case "default":
        case "day":
            endDate = moment(date).tz(tz).startOf("day").add(1, "d").subtract(1, "s");
            break;
        case "week":
            endDate = moment(date).tz(tz).startOf("day").add(7, "d").subtract(1, "s");
            break;
        case "month":
            endDate = moment(date).tz(tz).startOf("day").add(1, "M").subtract(1, "s");
            break;
        case "year":
            endDate = moment(date).tz(tz).startOf("day").add(1, "y").subtract(1, "s");
            break;
    }

    let filterEndDate;

    if (filters.duration !== "custom") filterEndDate = moment().tz(tz);

    if (filters.duration === "lastmonth" || filters.duration === "month") {
        filterEndDate = moment().tz(tz).startOf("month").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (filters.duration === "lastquarter" || filters.duration === "last2quarter") {
        filterEndDate = moment().tz(tz).startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else {
        // if (!filters.rollingDate && filters.duration === "custom") filterEndDate = moment(filters.endDateTime);
        // else filterEndDate = moment().tz(tz);

        if (filters.rollingDate) filterEndDate = moment().tz(tz);
    }

    if (moment(moment(endDate).format("YYYY-MM-DDTHH:mm:ss")).isAfter(moment(filterEndDate).format("YYYY-MM-DDTHH:mm:ss"))) {
        if (filters.duration === "custom") {
            if (filters.rollingDate !== true) endDate = moment(filterEndDate);
            else endDate = "rollingdate";
        } else endDate = moment(filterEndDate);
    }

    if (moment(endDate).isAfter(moment().tz(tz))) endDate = moment().tz(tz);

    if (lastComparisonIndex && moment(endDate, "DD/MM/YYYY HH:mm:ss").diff(moment(moment().tz(tz), "DD/MM/YYYY HH:mm:ss")) !== 0) {
        endDate = moment(comparisionData.date.end_date);
    }

    return endDate;
};

export const getViewConversationDuration = (d, newFilter, aggs_val, filters, comparisionData, lastComparisonIndex, comparisonAppliedFilter) => {
    console.log("firstcomparisionData", d, newFilter, aggs_val, filters);
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    newFilter.rollingDate = false;
    newFilter.duration = "custom";

    let newDate = moment(d.dataId ? d.dataId : d.originalX ? d.originalX : d.x).tz(tz);
    newFilter.startDateTime = newDate;
    newFilter.endDateTime =
        aggs_val === "hour"
            ? moment(newDate).tz(tz).endOf("hour")
            : getEndDate({ date: newDate, aggVal: aggs_val, filters: filters, comparisionData: comparisionData, lastComparisonIndex: lastComparisonIndex });

    if (aggs_val === "hour" && newFilter.endDateTime.isAfter(moment().tz(tz))) {
        newFilter.endDateTime = moment().tz(tz);
    }

    if (newFilter.endDateTime === "rollingdate") {
        newFilter.endDateTime = moment();
        newFilter.rollingDate = true;
    }

    newFilter.startDateTime = newFilter.startDateTime.tz(tz).format("YYYY-MM-DDTHH:mm:ss");
    if (filters.duration === "custom" || filters.duration === "lastmonth" || filters.duration === "lastquarter" || filters.duration === "last2quarter")
        newFilter.endDateTime = newFilter.endDateTime.format("YYYY-MM-DDTHH:mm:ss");
    else newFilter.endDateTime = newFilter.endDateTime.tz(tz).format("YYYY-MM-DDTHH:mm:ss");

    if (lastComparisonIndex && aggs_val === "hour") {
        newFilter.endDateTime = comparisonAppliedFilter.end_date;
    }

    return newFilter;
};

export const isHourly = (data) => {
    if (data.xs.length < 2) return false;
    return data.xs[1] - data.xs[0] < 24 * 59 * 60 * 1000;
};

export function numberWithCommas(x) {
    if (x === null) return false;
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

export function kmFormatter(num) {
    return Math.abs(num) > 999999
        ? Math.sign(num) * (Math.abs(num) / 1000000).toFixed(1) + "m"
        : Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
}

export const addTitle = (chart) => {
    let css, text;
    if (chart.title) {
        text = chart.title.textStr;
        chart.title.destroy();
    }

    let r = chart.renderer,
        x = chart.series[0].center[0] + chart.plotLeft,
        y = chart.series[0].center[1] + chart.plotTop;
    chart.title = r.text(text, 0, 0).css(css).hide().add();
    chart.title
        .attr({
            x: x,
            y: y,
            "dominant-baseline": "middle",
            "text-anchor": "middle",
        })
        .show();
};
export const convertToTitleCase = (input) => {
    const words = input.split("_");
    const formattedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
    return formattedWords.join(" ");
};

export const toTitleCase = (str) => {
    if (str == "linkedin") {
        return "LinkedIn";
    }
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

const toFixed = (num, limit) => {
    num = num.toString();
    num = num.slice(0, num.indexOf(".") + limit);
    return Number(num);
};

export const kFormatter = (num = 0) => {
    if (isNaN(num)) return 0;

    if (Math.abs(num) > 99999999) {
        if (Math.abs(num) % 1000000000 === 0) return Math.abs(num) / 1000000000 + "B";
        return toFixed(Math.abs(num) / 1000000000, 3) + "B";
    } else if (Math.abs(num) > 99999) {
        if (Math.abs(num) % 1000000 === 0) return Math.abs(num) / 1000000 + "M";
        return toFixed(Math.abs(num) / 1000000, 3) + "M";
    } else if (Math.abs(num) > 999) {
        if (Math.abs(num) % 1000 === 0) return Math.abs(num) / 1000 + "K";
        return toFixed(Math.abs(num) / 1000, 3) + "K";
    } else return Math.abs(num);
};

export const percentageFormatter = (num = 0) => {
    if (!isFinite(num)) return 0;

    if (num > 99999999) {
        if (num % 1000000000 === 0) return num / 1000000000 + "B";
        return toFixed(num / 1000000000, 2) + "B";
    } else if (num > 99999) {
        if (num % 1000000 === 0) return num / 1000000 + "M";
        return toFixed(num / 1000000, 2) + "M";
    } else if (num > 999) {
        if (num % 1000 === 0) return num / 1000 + "K";
        return toFixed(num / 1000, 2) + "K";
    } else {
        if (num.toString().split(".")[1] === "0") return Math.abs(num);
        else return num;
    }
};

export const postOrderList = [
    { label: "Ascending", value: "asc" },
    { label: "Descending", value: "desc" },
];

export const postOrderByList = [
    { label: "Most Recent", value: "date_desc", param: "post.published_date" },
    { label: "Least Recent", value: "date_asc", param: "post.published_date" },
    { label: "Most Liked", value: "like_count_desc", param: "post.engagement_values.like_count" },
    { label: "Least Liked", value: "like_count_asc", param: "post.engagement_values.like_count" },
    { label: "Most Comments", value: "comment_count_desc", param: "post.engagement_values.comment_count" },
    { label: "Least Comments", value: "comment_count_asc", param: "post.engagement_values.comment_count" },
    { label: "Most Shares", value: "share_count_desc", param: "post.engagement_values.share_count" },
    { label: "Least Shares", value: "share_count_asc", param: "post.engagement_values.share_count" },
    { label: "Most Engaging", value: "impact_value-desc", param: "impact_value" },
    { label: "Least Engaging", value: "impact_value-asc", param: "impact_value" },
];

export const storiesOrderByList = [
    { label: "Most Recent", value: "date_desc", param: "post.published_date" },
    { label: "Least Recent", value: "date_asc", param: "post.published_date" },
    { label: "Most impression", value: "impression_count_desc", param: "post.engagement_values.impressions_count" },
    { label: "Least impression", value: "impression_count_asc", param: "post.engagement_values.impressions_count" },
    { label: "Most views", value: "views_count_desc", param: "post.engagement_values.impressions_count" },
    { label: "Least views", value: "views_count_asc", param: "post.engagement_values.impressions_count" },
    { label: "Most Replies", value: "comment_count_desc", param: "post.engagement_values.comment_count" },
    { label: "Least Replies", value: "comment_count_asc", param: "post.engagement_values.comment_count" },
    { label: "Most exited", value: "exit_count_desc", param: "post.engagement_values.exits_count" },
    { label: "Least exited", value: "exit_count_asc", param: "post.engagement_values.exits_count" },
    { label: "Most tapped forward", value: "tapped_forward-desc", param: "post.engagement_values.taps_forward_count" },
    { label: "Least tapped forward", value: "tapped_forward-asc", param: "post.engagement_values.taps_forward_count" },
    { label: "Most tapped back", value: "tapped_backward-desc", param: "post.engagement_values.taps_back_count" },
    { label: "Least tapped back", value: "tapped_backward-asc", param: "post.engagement_values.taps_back_count" },
];
